module.exports = __webpack_public_path__ + "img/61.6.CODm.b2e9bd35.png";